import React from 'react';
import { ClockIcon, MapPinIcon, PhoneIcon, MailIcon, MessageCircleIcon, HeartIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { contact, schedule, policies } from '../data/site';
export function InfoFooter() {
  return <footer id="contacto" className="bg-brand-ink px-5 py-14 sm:px-8 sm:py-16" data-id="element-45" data-mp="3kcytg2g9rhpm">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12 lg:gap-12" data-id="element-46" data-mp="3pagznl2wjitx">
        <Reveal className="lg:col-span-4" data-id="element-47" data-mp="gvgk1qkum2n3">
          <div data-id="element-48" data-mp="gwhx20lfcz7g">
            <h2 className="inline-flex items-center gap-3 font-display text-3xl tracking-wide text-white sm:text-4xl" data-id="element-49" data-mp="lsywvs1zl20d">
              <ClockIcon className="h-6 w-6 text-brand-red" aria-hidden="true" data-id="element-50" data-mp="7540o1orsfij" />
              Horarios de atención
            </h2>
            <dl className="mt-6 space-y-4" data-id="element-51" data-mp="c1uhir8eff50">
              {schedule.map(slot => <div key={slot.days} className="border-l-2 border-brand-red pl-4" data-id="element-52" data-mp="zs80ls90a3ng">
                  <dt className="font-sans text-sm tracking-[0.18em] text-white/60" data-id="element-53" data-mp="14lkog05v26f5">
                    {slot.days.toUpperCase()}
                  </dt>
                  <dd className="font-display text-3xl text-brand-red" data-id="element-54" data-mp="k91tyfupbvb8">
                    {slot.hours}
                  </dd>
                </div>)}
            </dl>
          </div>
        </Reveal>

        <Reveal className="lg:col-span-4" delay={0.06} data-id="element-55" data-mp="u4llkq28g7u6">
          <div data-id="element-56" data-mp="17x1si1y98q0d">
            <h2 className="font-display text-3xl tracking-wide text-white sm:text-4xl" data-id="element-57" data-mp="17wrxu129luoc">
              Contacto
            </h2>
            <ul className="mt-6 space-y-4 font-sans text-sm text-white/80" data-id="element-58" data-mp="12xyjy7j2g1nn">
              <li className="flex gap-3" data-id="element-59" data-mp="1hupp6xff87l6">
                <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-red" aria-hidden="true" data-id="element-60" data-mp="1hto8odfmysw2" />
                <span data-id="element-61" data-mp="3jo5ftubidmg5">{contact.address}</span>
              </li>
              <li className="flex gap-3" data-id="element-62" data-mp="3eo0zc4alorpx">
                <PhoneIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-red" aria-hidden="true" data-id="element-63" data-mp="3epcc2tm0x9t6" />
                <span data-id="element-64" data-mp="c8dw60hwsxsu">
                  <span className="font-semibold tracking-wide text-brand-red" data-id="element-65" data-mp="c7ufso7wqhgx">
                    TELÉFONO:{' '}
                  </span>
                  <a href={contact.phoneHref} className="transition-colors duration-200 ease-smooth hover:text-white" data-id="element-66" data-mp="h5vyh81f8erv">
                    {contact.phone}
                  </a>
                </span>
              </li>
              <li className="flex gap-3" data-id="element-67" data-mp="v66pcb2qdtd1">
                <MessageCircleIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-wa" aria-hidden="true" data-id="element-68" data-mp="v4vjm5pq6bja" />
                <span data-id="element-69" data-mp="14w00xc2vi8ha">
                  <span className="font-semibold tracking-wide text-brand-red" data-id="element-70" data-mp="14w9o6rwja1ja">
                    WHATSAPP:{' '}
                  </span>
                  <a href={contact.whatsappHref} className="transition-colors duration-200 ease-smooth hover:text-white" data-id="element-71" data-mp="1euz8erbwjy2p">
                    {contact.whatsapp}
                  </a>
                </span>
              </li>
              <li className="flex gap-3" data-id="element-72" data-mp="2ugj9xs5y2kgv">
                <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-red" aria-hidden="true" data-id="element-73" data-mp="2pg53ufnwlklh" />
                <span data-id="element-74" data-mp="2kidb5jffpug8">
                  <span className="font-semibold tracking-wide text-brand-red" data-id="element-75" data-mp="3i3hnagyrpcak">
                    CORREO:{' '}
                  </span>
                  <a href={`mailto:${contact.email}`} className="break-all transition-colors duration-200 ease-smooth hover:text-white" data-id="element-76" data-mp="3d5zdkocxet1i">
                    {contact.email}
                  </a>
                </span>
              </li>
            </ul>
          </div>
        </Reveal>

        <Reveal className="lg:col-span-4" delay={0.12} data-id="element-77" data-mp="3w3iqw46f2xtq">
          <div data-id="element-78" data-mp="3w2qx8ywdra63">
            <h2 className="font-sans text-sm font-bold tracking-[0.22em] text-white/90" data-id="element-79" data-mp="3w27oa7opjw47">
              POLITICAS DEL SITIO
            </h2>
            <div className="mt-5 space-y-3 font-sans text-[11px] leading-relaxed text-white/45" data-id="element-80" data-mp="3lkcae87omcx9">
              {policies.split('\n\n').map(paragraph => <p key={paragraph.slice(0, 24)} data-id="element-81" data-mp="36p5zb6tqbnx2">{paragraph}</p>)}
            </div>
          </div>
        </Reveal>
      </div>

      <div className="mx-auto mt-16 flex max-w-6xl flex-col items-center gap-3 border-t border-white/10 pt-8 text-center sm:flex-row sm:justify-between sm:text-left" data-id="element-82" data-mp="36wb2vsxkpqy">
        <p className="inline-flex items-center gap-2 font-display text-lg tracking-[0.12em] text-white/80" data-id="element-83" data-mp="87s9ituijjoz">
          <HeartIcon className="h-4 w-4 text-brand-red" aria-hidden="true" data-id="element-84" data-mp="3pkcv2aldjkcr" />
          AMARRES Y ENCANTAMIENTOS
        </p>
        <p className="font-sans text-xs text-white/40" data-id="element-85" data-mp="m4yrwnbbrgdo">
          © {new Date().getFullYear()} Amarres y Encantamientos. Solo para
          mayores de 18 años.
        </p>
      </div>
    </footer>;
}